export default __webpack_public_path__ + "static/media/btn_preorder.3f634ecc.png";